export default "__VITE_ASSET__Bh7yNd9Z__"